(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-menu-trigger]');
      this.overlay = document.querySelector('[data-menu-overlay]');
      this.closeBtn = this.overlay.querySelector('[data-menu-close]');

      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight);
      this.observeDarkSections();

      this.trigger.addEventListener('click', () => this.open());
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', (event) => {
        if (event.target === this.overlay || event.target === this.overlay.querySelector('.site-header-overlay__blur')) {
          this.close();
        }
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    open() {
      this.overlay.hidden = false;
      requestAnimationFrame(() => this.overlay.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(() => {
        this.overlay.hidden = true;
      }, 350);
    }

    setHeaderHeight() {
      const height = this.querySelector('.site-header__row').offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    /*
     * Colours the menu text by what is actually behind it: white over dark images or
     * backgrounds, black over light ones. The left (MENU) and right (LOGIN / CART)
     * sides are measured separately. Falls back to [data-header-invert] sections
     * (needed for videos, which cannot be sampled).
     */
    observeDarkSections() {
      this.imageCache = new Map();
      this.fallbackInverted = false;
      this.tone = { left: null, right: null };

      const fallbackTargets = new Set();
      const targets = document.querySelectorAll('[data-header-invert]');
      if (targets.length) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) fallbackTargets.add(entry.target);
              else fallbackTargets.delete(entry.target);
            });
            this.fallbackInverted = fallbackTargets.size > 0;
            this.scheduleTone();
          },
          { rootMargin: '-50% 0px -50% 0px' }
        );
        targets.forEach((target) => observer.observe(target));
      }

      window.addEventListener('scroll', () => this.scheduleTone(), { passive: true });
      window.addEventListener('resize', () => this.scheduleTone());
      window.addEventListener('load', () => this.scheduleTone());
      document.addEventListener('load', () => this.scheduleTone(), true);
      this.scheduleTone();
    }

    scheduleTone() {
      if (this.toneFrame) return;
      this.toneFrame = requestAnimationFrame(() => {
        this.toneFrame = null;
        this.updateTone();
      });
    }

    updateTone() {
      if (this.overlay && !this.overlay.hidden) return;
      const row = this.querySelector('.site-header__row');
      const rowRect = row.getBoundingClientRect();
      const y = Math.min(rowRect.bottom - 2, window.innerHeight - 1);
      const menu = this.querySelector('[data-menu-trigger]').getBoundingClientRect();
      const right = this.querySelector('.site-header__right').getBoundingClientRect();

      const left = this.sampleDark(menu.left + menu.width / 2, y);
      const rightSide = this.sampleDark(right.left + right.width / 2, y);

      const leftDark = left === null ? this.fallbackInverted : left;
      const rightDark = rightSide === null ? this.fallbackInverted : rightSide;

      this.classList.toggle('is-inverted-left', leftDark && !rightDark);
      this.classList.toggle('is-inverted-right', rightDark && !leftDark);
      this.classList.toggle('is-inverted', leftDark && rightDark);
    }

    // true = dark, false = light, null = cannot tell
    sampleDark(x, y) {
      const stack = document.elementsFromPoint(x, y);
      for (const el of stack) {
        if (el.closest('site-header, [data-menu-overlay], .newsletter-bar, mm-cart-drawer')) continue;
        const tone = el.closest('[data-header-tone]');
        if (tone) return tone.getAttribute('data-header-tone') === 'dark';
        if (el.tagName === 'IMG') {
          const result = this.imageIsDark(el, x, y);
          if (result !== null) return result;
          continue;
        }
        if (el.tagName === 'VIDEO') return null;
        const bg = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
        if (bg && (bg.length < 4 || parseFloat(bg[3]) > 0.9)) {
          return this.luminance(+bg[0], +bg[1], +bg[2]) < 0.45;
        }
      }
      return null;
    }

    luminance(r, g, b) {
      return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    }

    imageIsDark(img, x, y) {
      if (!img.complete || !img.naturalWidth) return null;
      const src = img.currentSrc || img.src;
      let entry = this.imageCache.get(src);
      if (entry === undefined) {
        entry = { data: null, failed: false };
        this.imageCache.set(src, entry);
        const copy = new Image();
        copy.crossOrigin = 'anonymous';
        copy.onload = () => {
          try {
            const scale = Math.min(1, 320 / copy.naturalWidth);
            const canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.round(copy.naturalWidth * scale));
            canvas.height = Math.max(1, Math.round(copy.naturalHeight * scale));
            const ctx = canvas.getContext('2d', { willReadFrequently: true });
            ctx.drawImage(copy, 0, 0, canvas.width, canvas.height);
            entry.data = ctx.getImageData(0, 0, canvas.width, canvas.height);
          } catch (e) {
            entry.failed = true;
          }
          this.scheduleTone();
        };
        copy.onerror = () => { entry.failed = true; };
        copy.src = src;
        return null;
      }
      if (!entry.data) return null;

      const rect = img.getBoundingClientRect();
      const fit = getComputedStyle(img).objectFit;
      const nw = img.naturalWidth;
      const nh = img.naturalHeight;
      let sx = rect.width / nw;
      let sy = rect.height / nh;
      if (fit === 'cover') sx = sy = Math.max(sx, sy);
      else if (fit === 'contain' || fit === 'scale-down') sx = sy = Math.min(sx, sy);
      else if (fit !== 'fill') sx = sy = 1;
      const offsetX = (rect.width - nw * sx) / 2;
      const offsetY = (rect.height - nh * sy) / 2;
      const px = (x - rect.left - offsetX) / sx / nw;
      const py = (y - rect.top - offsetY) / sy / nh;
      if (px < 0 || px > 1 || py < 0 || py > 1) return null;

      const { width, height, data } = entry.data;
      const cx = Math.round(px * (width - 1));
      const cy = Math.round(py * (height - 1));
      let sum = 0;
      let count = 0;
      for (let dy = -4; dy <= 4; dy++) {
        for (let dx = -12; dx <= 12; dx++) {
          const ix = Math.min(width - 1, Math.max(0, cx + dx));
          const iy = Math.min(height - 1, Math.max(0, cy + dy));
          const i = (iy * width + ix) * 4;
          sum += this.luminance(data[i], data[i + 1], data[i + 2]);
          count++;
        }
      }
      return sum / count < 0.45;
    }
  }

  customElements.define('site-header', SiteHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-title"] && !Shopify.designMode) return;
  try {
    
  class HeroTitle extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-hero-scroll]');
      this.items = Array.from(this.querySelectorAll('[data-hero-item]'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));

      if (!this.scroller || this.items.length < 2) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const item = this.items[parseInt(dot.dataset.index, 10)];
          item?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        });
      });

      this.onScroll = this.onScroll.bind(this);
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });

      this.onWheel = this.onWheel.bind(this);
      this.scroller.addEventListener('wheel', this.onWheel, { passive: false });

      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);
      this.scroller.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.scroller.addEventListener('touchmove', this.onTouchMove, { passive: false });

      // Land on the middle (main title) item on first paint, no smooth
      // animation for the initial snap.
      const mainItem = this.querySelector('.hero-title__main')?.closest('[data-hero-item]');
      if (mainItem) {
        this.scroller.style.scrollBehavior = 'auto';
        mainItem.scrollIntoView({ block: 'center' });
        requestAnimationFrame(() => {
          this.scroller.style.scrollBehavior = '';
        });
      }

      this.updateCurrent();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.updateCurrent();
        this.ticking = false;
      });
    }

    atBoundary(deltaY) {
      const currentIndex = this.items.findIndex((item) => item.classList.contains('is-current'));
      const maxScroll = this.scroller.scrollHeight - this.scroller.clientHeight;

      if (deltaY > 0) {
        return currentIndex === this.items.length - 1 && this.scroller.scrollTop >= maxScroll - 4;
      }
      if (deltaY < 0) {
        return currentIndex === 0 && this.scroller.scrollTop <= 4;
      }
      return false;
    }

    onWheel(event) {
      if (this.atBoundary(event.deltaY)) {
        event.preventDefault();
        window.scrollBy(0, event.deltaY);
      }
    }

    onTouchStart(event) {
      this.touchY = event.touches[0].clientY;
    }

    onTouchMove(event) {
      const currentY = event.touches[0].clientY;
      const deltaY = this.touchY - currentY;

      if (this.atBoundary(deltaY)) {
        event.preventDefault();
        window.scrollBy(0, deltaY);
      }

      this.touchY = currentY;
    }

    updateCurrent() {
      const containerRect = this.scroller.getBoundingClientRect();
      const center = containerRect.top + containerRect.height / 2;

      let closest = null;
      let closestDistance = Infinity;

      this.items.forEach((item) => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.top + rect.height / 2;
        const distance = Math.abs(itemCenter - center);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = item;
        }
      });

      this.items.forEach((item) => item.classList.toggle('is-current', item === closest));

      const closestIndex = closest ? parseInt(closest.dataset.index, 10) : -1;
      this.dots.forEach((dot) => {
        dot.classList.toggle('is-active', parseInt(dot.dataset.index, 10) === closestIndex);
      });
    }
  }

  customElements.define('hero-title', HeroTitle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-chapters"] && !Shopify.designMode) return;
  try {
    
  class ChaptersPreview extends HTMLElement {
    connectedCallback() {
      this.images = Array.from(this.querySelectorAll('[data-chapter-image]'));
      this.querySelectorAll('[data-chapter-id]').forEach((item) => {
        const show = () => this.show(item.dataset.chapterId);
        item.addEventListener('mouseenter', show);
        item.addEventListener('focus', show);
        item.addEventListener('mouseleave', () => this.show(null));
        item.addEventListener('blur', () => this.show(null));
      });
    }

    show(id) {
      this.images.forEach((image) => image.classList.toggle('is-active', image.dataset.chapterImage === id));
    }
  }

  if (!customElements.get('chapters-preview')) customElements.define('chapters-preview', ChaptersPreview);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  class LookbookSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.lookbook__slide'));
      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.autoplayMobile = this.dataset.autoplayMobile === 'true';
      this.mobileQuery = window.matchMedia('(max-width: 749px)');

      this.updateAutoplay();
      this.mobileQuery.addEventListener('change', () => this.updateAutoplay());
    }

    show(index) {
      if (!this.slides.length) return;
      this.slides[this.index].classList.remove('is-active');
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
    }

    updateAutoplay() {
      window.clearInterval(this.timer);
      if (this.autoplayMobile && this.mobileQuery.matches && this.slides.length > 1) {
        this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }
  }

  customElements.define('lookbook-slideshow', LookbookSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-page"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.cart-page [data-qty-change]');
    if (!button) return;
    const item = button.closest('[data-cart-page-item]');
    const qtyEl = item.querySelector('[data-qty-value]');
    const next = Math.max(0, parseInt(qtyEl.textContent, 10) + parseInt(button.dataset.qtyChange, 10));
    item.querySelectorAll('[data-qty-change]').forEach((b) => (b.disabled = true));
    await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(item.dataset.line, 10), quantity: next }),
    });
    window.location.reload();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-archive"]) return;
  try {
    
  document.querySelectorAll('[data-product-card]').forEach((card) => {
    const sizeButtons = Array.from(card.querySelectorAll('[data-size-option]'));
    sizeButtons.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        sizeButtons.forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-shop"]) return;
  try {
    
  class ShopCollectionFilter extends HTMLElement {
    connectedCallback() {
      this.allInput = this.querySelector('[data-filter-tag="all"]');
      this.tagInputs = Array.from(this.querySelectorAll('input[data-filter-tag]')).filter((input) => input !== this.allInput);
      this.cards = Array.from(this.querySelectorAll('[data-product-card]'));

      this.allInput.addEventListener('change', () => {
        if (this.allInput.checked) {
          this.tagInputs.forEach((input) => (input.checked = false));
          this.apply();
        } else if (!this.tagInputs.some((input) => input.checked)) {
          this.allInput.checked = true;
        }
      });

      this.tagInputs.forEach((input) => {
        input.addEventListener('change', () => {
          const anyChecked = this.tagInputs.some((el) => el.checked);
          this.allInput.checked = !anyChecked;
          this.apply();
        });
      });
    }

    apply() {
      const activeTags = this.tagInputs.filter((input) => input.checked).map((input) => input.dataset.filterTag);
      const matches = (card) => {
        if (!activeTags.length) return true;
        const cardTags = (card.dataset.tags || '').split(',').filter(Boolean);
        return activeTags.some((tag) => cardTags.includes(tag));
      };

      const token = (this._token = (this._token || 0) + 1);
      this.cards.forEach((card) => card.getAnimations().forEach((animation) => animation.cancel()));

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const wasVisible = this.cards.filter((card) => !card.hidden);
      const leaving = wasVisible.filter((card) => !matches(card));
      const entering = this.cards.filter((card) => card.hidden && matches(card));

      if (reduce || (!leaving.length && !entering.length)) {
        this.cards.forEach((card) => (card.hidden = !matches(card)));
        return;
      }

      const ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
      const fadeOut = leaving.map((card) => card.animate(
        [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-8px)' }],
        { duration: 260, easing: 'ease-out', fill: 'forwards' }
      ).finished.catch(() => {}));

      Promise.all(fadeOut).then(() => {
        if (token !== this._token) return;

        const stayers = wasVisible.filter((card) => matches(card));
        const first = new Map(stayers.map((card) => [card, card.getBoundingClientRect()]));

        this.cards.forEach((card) => {
          card.getAnimations().forEach((animation) => animation.cancel());
          card.hidden = !matches(card);
        });

        stayers.forEach((card) => {
          const from = first.get(card);
          const to = card.getBoundingClientRect();
          const dx = from.left - to.left;
          const dy = from.top - to.top;
          if (!dx && !dy) return;
          card.animate(
            [{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'translate(0, 0)' }],
            { duration: 700, easing: ease }
          );
        });

        entering.forEach((card, index) => {
          card.animate(
            [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 700, delay: 120 + index * 50, easing: ease, fill: 'backwards' }
          );
        });
      });
    }
  }

  customElements.define('shop-collection-filter', ShopCollectionFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-detail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.product-detail__accordion > summary');
    if (!summary) return;
    const details = summary.parentElement;
    const content = details.querySelector('.product-detail__accordion-content');
    if (!content) return;
    event.preventDefault();

    if (details._mmAnim) details._mmAnim.cancel();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const opening = !details.open;

    if (opening) details.open = true;
    const full = content.scrollHeight;
    const frames = opening
      ? [{ height: '0px', opacity: 0 }, { height: full + 'px', opacity: 1 }]
      : [{ height: content.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }];

    if (reduce) {
      if (!opening) details.open = false;
      return;
    }

    details._mmAnim = content.animate(frames, { duration: 350, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
    details._mmAnim.onfinish = () => {
      if (!opening) details.open = false;
      details._mmAnim = null;
    };
    details._mmAnim.oncancel = () => { details._mmAnim = null; };
  });

  class ProductDetailApp extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-product-json]').textContent);
      this.priceEl = this.querySelector('[data-product-price]');
      this.addButton = this.querySelector('[data-add-to-cart]');
      this.optionRows = Array.from(this.querySelectorAll('[data-option-row]'));
      this.selected = [];

      this.optionRows.forEach((row) => {
        const position = parseInt(row.dataset.optionPosition, 10) - 1;
        const selectedButton = row.querySelector('.is-selected');
        this.selected[position] = selectedButton ? selectedButton.dataset.value : row.querySelector('[data-option-value]')?.dataset.value;

        row.querySelectorAll('[data-option-value]').forEach((button) => {
          button.addEventListener('click', () => {
            row.querySelectorAll('[data-option-value]').forEach((b) => b.classList.remove('is-selected'));
            button.classList.add('is-selected');
            this.selected[position] = button.dataset.value;
            this.updateVariant();
          });
        });
      });

      this.gallery = this.querySelector('[data-gallery]');
      this.cursor = this.querySelector('[data-scroll-cursor]');
      if (this.gallery && this.cursor) {
        this.seen = this.cursor.querySelector('.scroll-cursor__seen');
        this.gallery.addEventListener('scroll', () => this.updateScrollProgress(), { passive: true });
        this.updateScrollProgress();
      }

      // Colors and Size always stay on one line: when the names are long, the text gets smaller.
      this.optionsEl = this.querySelector('.product-detail__options');
      this.fitOptions = this.fitOptions.bind(this);
      this.fitOptions();
      window.addEventListener('resize', this.fitOptions);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.fitOptions);

      this.updateVariant();

      this.addButton.addEventListener('click', () => this.addToCart());
    }

    findVariant() {
      return this.variants.find((variant) => {
        return ['option1', 'option2', 'option3'].every((key, index) => {
          return this.selected[index] == null || variant[key] === this.selected[index];
        });
      });
    }

    updateVariant() {
      const variant = this.findVariant();
      if (!variant) {
        this.addButton.disabled = true;
        return;
      }

      this.currentVariant = variant;
      this.priceEl.textContent = this.formatMoney(variant.price);
      this.addButton.disabled = !variant.available;
      this.addButton.textContent = variant.available
        ? this.addButton.dataset.addLabel || this.addButton.textContent
        : 'Sold out';

      this.showVariantImage(variant);
    }

    fitOptions() {
      const el = this.optionsEl;
      if (!el) return;
      el.style.fontSize = '';
      let size = parseFloat(getComputedStyle(el).fontSize);
      const min = 9;
      while (el.scrollWidth > el.clientWidth + 1 && size > min) {
        size -= 0.5;
        el.style.fontSize = `${size}px`;
      }
    }

    // Picking a colour brings that colour's photo into view in the gallery.
    // Order: the exact variant's image, any variant of the same colour that has an image,
    // then a photo whose alt text or file name contains the colour name.
    showVariantImage(variant) {
      if (!this.gallery) return;

      const findMedia = (id) => (id ? this.gallery.querySelector(`[data-media-id="${id}"]`) : null);
      const colorRow = this.optionRows.find((row) => row.dataset.optionKind === 'color');
      const colorIndex = colorRow ? parseInt(colorRow.dataset.optionPosition, 10) - 1 : -1;
      const color = colorIndex >= 0 ? String(this.selected[colorIndex] || '').trim().toLowerCase() : '';

      let media = variant.featured_image ? findMedia(variant.featured_image.id) : null;

      if (!media && colorIndex >= 0) {
        const key = `option${colorIndex + 1}`;
        const sameColor = this.variants.find((item) => {
          return item.featured_image && String(item[key] || '').trim().toLowerCase() === color;
        });
        if (sameColor) media = findMedia(sameColor.featured_image.id);
      }

      if (!media && color) {
        const slug = color.replace(/[^a-z0-9]+/g, '');
        media = Array.from(this.gallery.querySelectorAll('[data-media-id]')).find((item) => {
          const img = item.querySelector('img');
          const alt = (img?.getAttribute('alt') || '').toLowerCase();
          const file = decodeURIComponent((img?.getAttribute('src') || '').split('?')[0].split('/').pop() || '').toLowerCase();
          return alt.includes(color) || file.replace(/[^a-z0-9]+/g, '').includes(slug);
        });
      }

      if (!media) return;
      const left = media.getBoundingClientRect().left - this.gallery.getBoundingClientRect().left + this.gallery.scrollLeft;
      // Jump straight to the colour's photo (no long scroll across the whole strip),
      // with a quick fade out and in so the change still feels smooth.
      const jump = () => this.gallery.scrollTo({ left, behavior: 'auto' });
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      clearTimeout(this.switchTimer);
      if (!this.hasShownVariant || reduce) {
        jump();
      } else {
        this.gallery.classList.add('is-switching');
        this.switchTimer = setTimeout(() => {
          jump();
          requestAnimationFrame(() => this.gallery.classList.remove('is-switching'));
        }, 160);
      }
      this.hasShownVariant = true;
    }

    formatMoney(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      });
    }

    async addToCart() {
      if (!this.currentVariant) return;
      this.addButton.disabled = true;
      try {
        await window.MMCart.add(this.currentVariant.id);
      } finally {
        this.addButton.disabled = !this.currentVariant.available;
      }
    }

    updateScrollProgress() {
      const maxScroll = this.gallery.scrollWidth - this.gallery.clientWidth;
      const progress = maxScroll > 0 ? this.gallery.scrollLeft / maxScroll : 1;
      const visible = this.gallery.scrollWidth > 0 ? this.gallery.clientWidth / this.gallery.scrollWidth : 1;
      const seen = visible + progress * (1 - visible);
      this.seen.style.width = `${seen * 100}%`;
    }
  }

  customElements.define('product-detail-app', ProductDetailApp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manifesto"] && !Shopify.designMode) return;
  try {
    
  class ManifestoSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.manifesto__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-manifesto-dot]'));
      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.autoplayMobile = this.dataset.autoplayMobile === 'true';
      this.autoplayDesktop = this.dataset.autoplayDesktop === 'true';
      this.mobileQuery = window.matchMedia('(max-width: 749px)');

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.show(parseInt(dot.dataset.dotIndex, 10)));
      });

      this.updateAutoplay();
      this.mobileQuery.addEventListener('change', () => this.updateAutoplay());
    }

    show(index) {
      if (!this.slides.length) return;
      this.slides[this.index].classList.remove('is-active');
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
      this.dots.forEach((dot) => {
        dot.classList.toggle('is-active', parseInt(dot.dataset.dotIndex, 10) === this.index);
      });
    }

    updateAutoplay() {
      window.clearInterval(this.timer);
      const shouldAutoplay = this.mobileQuery.matches ? this.autoplayMobile : this.autoplayDesktop;
      if (shouldAutoplay && this.slides.length > 1) {
        this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }
  }

  customElements.define('manifesto-slideshow', ManifestoSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals"] && !Shopify.designMode) return;
  try {
    
  class ArrivalsCarousel extends HTMLElement {
    connectedCallback() {
      this.cursor = this.parentElement.querySelector('[data-scroll-cursor]');
      this.seen = this.cursor.querySelector('.scroll-cursor__seen');

      this.popup = this.parentElement.querySelector('[data-size-popup]');
      document.body.appendChild(this.popup);
      this.popupTitle = this.popup.querySelector('[data-size-popup-title]');
      this.popupPrice = this.popup.querySelector('[data-size-popup-price]');
      this.popupSizes = this.popup.querySelector('[data-size-popup-sizes]');
      this.popupAdd = this.popup.querySelector('[data-size-popup-add]');

      this.popup.querySelectorAll('[data-size-popup-close]').forEach((el) => {
        el.addEventListener('click', () => this.closeSizePopup());
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeSizePopup();
      });

      this.addEventListener('scroll', () => this.updateProgress());

      this.querySelectorAll('[data-product-card]').forEach((card) => this.initCard(card));

      this.updateProgress();
    }

    updateProgress() {
      const maxScroll = this.scrollWidth - this.clientWidth;
      const progress = maxScroll > 0 ? this.scrollLeft / maxScroll : 1;
      const visible = this.scrollWidth > 0 ? this.clientWidth / this.scrollWidth : 1;
      const seen = visible + progress * (1 - visible);
      this.seen.style.width = `${seen * 100}%`;
    }

    async addToCart(variantId, button) {
      button.disabled = true;
      try {
        await window.MMCart.add(variantId);
        this.closeSizePopup();
      } finally {
        button.disabled = false;
      }
    }

    openSizePopup(card, sizeButtons) {
      const title = card.querySelector('.new-arrivals__title')?.textContent.trim() || '';
      const price = card.querySelector('.new-arrivals__row > span')?.textContent.trim() || '';

      this.popupTitle.textContent = title;
      this.popupPrice.textContent = price;
      this.popupSizes.innerHTML = '';
      this.popupAdd.disabled = true;

      let selectedVariantId = null;

      sizeButtons.forEach((sourceBtn) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'size-popup__size';
        btn.innerHTML = '<span class="size-popup__size-mark"></span><span class="size-popup__size-value"></span>';
        btn.querySelector('.size-popup__size-value').textContent = sourceBtn.textContent.trim();
        btn.disabled = sourceBtn.disabled;
        btn.dataset.variantId = sourceBtn.dataset.variantId;

        btn.addEventListener('click', () => {
          this.popupSizes.querySelectorAll('.size-popup__size').forEach((b) => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          selectedVariantId = btn.dataset.variantId;
          this.popupAdd.disabled = false;

          sizeButtons.forEach((b) => b.classList.toggle('is-selected', b === sourceBtn));
        });

        this.popupSizes.appendChild(btn);
      });

      this.popupAdd.onclick = () => {
        if (!selectedVariantId) return;
        this.addToCart(selectedVariantId, this.popupAdd);
      };

      this.popup.hidden = false;
      requestAnimationFrame(() => {
        this.popup.classList.add('is-open');
        document.body.classList.add('has-size-popup');
      });
      document.body.style.overflow = 'hidden';
    }

    closeSizePopup() {
      this.popup.classList.remove('is-open');
      document.body.classList.remove('has-size-popup');
      document.body.style.overflow = '';
      window.setTimeout(() => {
        this.popup.hidden = true;
      }, 300);
    }

    initCard(card) {
      const sizeButtons = Array.from(card.querySelectorAll('[data-size-option]'));
      const addButton = card.querySelector('[data-add-to-cart]');
      if (!addButton || addButton.disabled) return;

      let selectedVariantId = null;

      sizeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          sizeButtons.forEach((b) => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          selectedVariantId = btn.dataset.variantId;
        });
      });

      addButton.addEventListener('click', () => {
        if (!selectedVariantId) {
          this.openSizePopup(card, sizeButtons);
          return;
        }
        this.addToCart(selectedVariantId, addButton);
      });
    }
  }

  customElements.define('arrivals-carousel', ArrivalsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists"] && !Shopify.designMode) return;
  try {
    
  class StockistsMap extends HTMLElement {
    connectedCallback() {
      this.pins = Array.from(this.querySelectorAll('[data-stockists-pin]'));

      this.querySelectorAll('.stockists__pin-panel-inner').forEach((inner) => {
        Array.from(inner.children).forEach((child, index) => child.style.setProperty('--i', Math.min(index, 14)));
      });

      this.pins.forEach((pin) => {
        if (pin.classList.contains('is-primary')) return;

        const trigger = pin.querySelector('[data-stockists-trigger]');
        if (!trigger) return;

        trigger.addEventListener('click', (event) => {
          event.stopPropagation();
          const isOpen = pin.classList.contains('is-open');
          this.closeAll();
          if (!isOpen) {
            pin.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          }
          this.makeRoom();
        });
      });

      window.addEventListener('resize', () => this.makeRoom());
      this.makeRoom();

      document.addEventListener('click', () => this.closeAll());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeAll();
      });
    }

    closeAll() {
      this.pins.forEach((pin) => {
        if (pin.classList.contains('is-primary')) return;
        pin.classList.remove('is-open');
        pin.querySelector('[data-stockists-trigger]')?.setAttribute('aria-expanded', 'false');
      });
      this.makeRoom();
    }

    // Grow the space below the map only while an open panel hangs past its bottom edge.
    makeRoom() {
      const mapBottom = this.getBoundingClientRect().bottom;
      let overflow = 0;
      this.pins.forEach((pin) => {
        if (!pin.classList.contains('is-open')) return;
        const panel = pin.querySelector('.stockists__pin-panel');
        if (!panel) return;
        const inner = panel.querySelector('.stockists__pin-panel-inner');
        if (!inner) return;
        // Measure the final height, not the height mid-animation
        const finalBottom = panel.getBoundingClientRect().top + inner.scrollHeight;
        overflow = Math.max(overflow, finalBottom - mapBottom);
      });
      this.style.marginBottom = overflow > 0 ? Math.ceil(overflow + 40) + 'px' : '';
    }
  }

  customElements.define('stockists-map', StockistsMap);

  } catch(e) { console.error(e); }
})();
})();
